<div class="card">
    <div class="card-header">
        <h4>{{ 'Header.Partners' | translate }}</h4>
    </div>
    <div class="card-body">
        <!-- Send Buttons -->
        <div class="d-flex gap-3 mb-3">
            <button class="btn btn-primary" data-toggle="modal" data-target="#sendToSubcontractorModal" (click)="loadPartners(); subcontractors.type = 'sendToPartner'">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="hero-icon mr-1 me-1">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5" />
                </svg>
                <span>{{ 'Buttons.SendToPartner' | translate }}</span>
            </button>
            <button class="btn btn-secondary" data-toggle="modal" data-target="#sendToSubcontractorModal" (click)="loadPartners(); subcontractors.type = 'offerRequest'">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="hero-icon mr-1 me-1">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M7.5 21L3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5" />
                  </svg>
                  <span>{{ 'Buttons.RequestOffer' | translate }}</span>
            </button>
        </div>
        <!-- Connected partners -->
        <table class="connectedPartners mb-3" *ngIf="!!subcontractors.connections" aria-label="Partners">
            <thead>
                <th class="text-center">{{ 'Standard.Partner' | translate }}</th>
            </thead>
            <tbody>
                <tr *ngIf="!!subcontractors.connections.fromPartner">
                    <td data-toggle="modal" data-target="#subcontractorCaseDetailsModal" (click)="getPartnerCaseDetails(subcontractors.connections.fromPartner)">
                        <div class="flex-between">
                            <div class="d-flex align-items-center gap-3">
                                <div class="btn btn-square btn-{{subcontractors.connections.fromPartner.companyName[0] | uppercase}}">{{subcontractors.connections.fromPartner.companyName[0] | uppercase}}</div>
                                <div class="flex-column">
                                    <div class="text-bold">{{ subcontractors.connections.fromPartner.companyName }}</div>
                                    <div class="text-normal">{{ subcontractors.connections.fromPartner.responsible.name }}</div>
                                </div>
                            </div>
                            <div>
                                <div class="badge" [ngClass]="subcontractors.getBadgeColor( subcontractors.connections.fromPartner.caseStatusId )">{{ subcontractors.connections.fromPartner.caseStatus | translate }}</div>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr *ngFor="let partner of subcontractors.connections.toPartners" data-toggle="modal" data-target="#subcontractorCaseDetailsModal" (click)="getPartnerCaseDetails(partner)">
                    <td>
                        <div class="flex-between">
                            <div class="d-flex align-items-center gap-3">
                                <div class="btn btn-square btn-{{partner.companyName[0] | uppercase}}">{{partner.companyName[0] | uppercase}}</div>
                                <div class="flex-column">
                                    <div class="text-bold">{{ partner.companyName }}</div>
                                    <div class="text-normal">{{ partner.responsible.name }}</div>
                                </div>
                            </div>
                            <div>
                                <span class="d-flex flex-nowrap text-small text-muted mb-3" title="{{ 'Offer.AcceptanceDate' | translate }}" *ngIf="!!partner.acceptanceDate">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="hero-icon mr-2">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>{{ partner.acceptanceDate + 'Z' | date:'dd-MM-yyyy HH:mm' }}
                                </span>
                                <span class="d-flex flex-nowrap text-small text-muted mb-3" title="{{ 'CaseStatus.Rejected' | translate }}" *ngIf="!!partner.rejectedDate">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="hero-icon mr-2">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>{{ partner.rejectedDate + 'Z' | date:'dd-MM-yyyy HH:mm' }}
                                </span>
                                <div class="badge badge-sm" [ngClass]="subcontractors.getBadgeColor( partner.caseStatusId )">{{ partner.caseStatus | translate }}</div>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr *ngFor="let partner of subcontractors.connections.waiting">
                    <td>
                        <div class="partnerRow flex-between">
                            <div class="d-flex align-items-center gap-3">
                                <div class="btn btn-square btn-{{partner.companyName[0] | uppercase}}">{{partner.companyName[0] | uppercase}}</div>
                                <div class="flex-column">
                                    <div class="text-bold">{{ partner.companyName }}</div>
                                    <div>{{ partner.partnerResponsible.name }}</div>
                                    <div class="d-flex justify-content-between flex-wrap text-muted">
                                        <span class="d-flex align-items-center flex-nowrap mr-3" *ngIf="!!partner.partnerResponsible.email">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="hero-icon mr-2">
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
                                            </svg>{{ partner.partnerResponsible.email }}
                                        </span>
                                        <span class="d-flex align-items-center flex-nowrap" *ngIf="!!partner.partnerResponsible.phone">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="hero-icon mr-2">
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
                                              </svg>{{ partner.partnerResponsible.phone }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="partnerRowDisplay">
                                <span class="d-flex flex-nowrap text-small text-muted mb-3" title="{{ 'Standard.Created' | translate }}">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="hero-icon mr-2">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>{{ partner.createdAt + 'Z' | date:'dd-MM-yyyy HH:mm' }}
                                </span>
                                <div class="partnerRowStatus">
                                    <span class="badge badge-light badge-sm" *ngIf="partner.status == 'bb7dcbad-b634-4d41-9b1b-480f25dd782b'">{{ 'CaseStatus.AwaitingAnswer' | translate }}</span>
                                    <span class="badge badge-danger badge-sm" *ngIf="partner.status == '789e1326-6655-4e98-bcd1-41c527e32d93'">{{ 'CaseStatus.Rejected' | translate }}</span>
                                </div>
                                <div class="partnerRowActions">
                                    <span class="badge badge-danger badge-sm cursor-pointer" (click)="cancelTransfer(partner)">{{ 'Buttons.Cancel' | translate }}</span>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <!-- No partners connected -->
        <div class="text-muted mb-3" *ngIf="!subcontractors.hasCasePartner()">{{ 'Partners.NoPartnersOnCase' | translate }}</div>
    </div>
</div>

<!-- Send to subcontractor modal -->
<div id="sendToSubcontractorModal" class="modal">
    <div class="modal-dialog">
        <div class="modal-content" *ngIf="subcontractors.sendToPartnerStep == 'choose'">
            <div class="modal-header">
                <h5>{{ 'Standard.Choose' | translate }} {{ ( 'Standard.Partner' | translate ) | lowercase }}</h5>
                <button type="button" class="close cursor-pointer" data-dismiss="modal" aria-label="Close">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 11L11 1M1 1L11 11" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </button>
            </div>
            <div class="modal-body">
                <div class="flex-between mb-3">
                    <input id="subcontractorSearch" type="text" class="form-control" [(ngModel)]="subcontractors.searchString" (keyup)="subcontractors.search()"
                        placeholder="{{ 'Standard.Search' | translate }} {{ ('Standard.Partner' | translate ) | lowercase }}">
                    <div class="d-flex">
                        <button class="btn" [ngClass]="!!subcontractors.filteredTradeGroups.length ? 'btn-secondary': 'btn-light'" data-toggle="modal" data-target="#filterTradeGroups">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="hero-icon">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 01-.659 1.591l-5.432 5.432a2.25 2.25 0 00-.659 1.591v2.927a2.25 2.25 0 01-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 00-.659-1.591L3.659 7.409A2.25 2.25 0 013 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0112 3z" />
                            </svg>
                        </button>
                        <button class="btn btn-secondary" *ngIf="!!subcontractors.filteredTradeGroups.length" (click)="subcontractors.filteredTradeGroups = []; subcontractors.search()">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="hero-icon">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                    <div class="ml-3 ms-3 d-flex gap-3" *ngIf="!!property">
                        <button class="btn" [ngClass]="!subcontractors.onlyPropertyContractors ? 'btn-secondary' : 'btn-light'" (click)="subcontractors.onlyPropertyContractors = false; loadPartners()">{{ 'Buttons.All' | translate
                            }}</button>
                        <button class="btn" [ngClass]="!!subcontractors.onlyPropertyContractors ? 'btn-secondary' : 'btn-light'" (click)="subcontractors.onlyPropertyContractors = true; loadPartners()">{{ 'Buttons.OnlyProperties' | translate
                            }}</button>
                    </div>
                </div>
                <div class="partnerChoiceList">
                    <table aria-label="Partner selection list">
                        <thead>
                            <th>{{ 'Standard.Partner' | translate }}</th>
                        </thead>
                        <tbody>
                            <tr class="noHover" *ngFor="let partner of subcontractors.displayed; trackBy:subcontractors.trackByCompanyId">
                                <td (click)="transferPartner = partner">
                                    <div class="partnerChoice flex-between">
                                        <div>
                                            <div class="d-flex align-items-center gap-3">
                                                <div class="btn btn-square btn-{{ getNameLetter(partner.name) | uppercase}}">{{ user.getInitials(partner.name)}}</div>
                                                <div>
                                                    {{ partner.name }}
                                                    <div class="text-small text-muted">{{ partner.tradeGroup?.name }}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="d-flex align-items-center">
                                            <div class="d-flex align-items-center gap-3 pr-2 text-right">
                                                <div class="text-muted text-nowrap" *ngIf="subcontractors.connectedParters.includes(partner.name)">{{ 'Partners.AlreadyChosen' | translate }}</div>
                                                <input class="form-control" type="radio" [(ngModel)]="transferPartner" [value]="partner" [disabled]="subcontractors.connectedParters.includes(partner.name)" />
                                            </div>
                                            <div class="partnerRemoval" *ngIf="!!property && subcontractors.onlyPropertyContractors">
                                                <button class="btn btn-sm btn-light text-small" (click)="removePartnerFromProperty(partner)" data-dismiss="modal" title="{{ 'CaseTransfer.RemoveFromProperty' | translate }}">
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="hero-icon">
                                                        <path stroke-linecap="round" stroke-linejoin="round"
                                                            d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="modal-footer justify-content-end">
                <button class="btn btn-secondary" data-dismiss="modal" (click)="reset()">{{ 'Buttons.Close' | translate }}</button>
                <button class="btn btn-primary" [disabled]="!transferPartner" (click)="createSendCase(transferPartner);subcontractors.sendToPartnerStep = 'form'">{{ 'Buttons.ContinueToCaseDetails' | translate }}</button>
            </div>
        </div>
        <div class="modal-content" *ngIf="subcontractors.sendToPartnerStep == 'form' && !!transferPartner ">
            <div class="modal-header">
                <h5 class="modal-title" id="pendingMessageModalLabel">{{ 'Standard.CaseDetails' | translate }}</h5>
                <div class="d-flex gap-3">
                    <div class="text-black cursor-pointer" (click)="openFileSelector()">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="black" class="hero-icon">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M18.375 12.739l-7.693 7.693a4.5 4.5 0 01-6.364-6.364l10.94-10.94A3 3 0 1119.5 7.372L8.552 18.32m.009-.01l-.01.01m5.699-9.941l-7.81 7.81a1.5 1.5 0 002.112 2.13" />
                        </svg>
                    </div>
                    <button type="button" class="close cursor-pointer" data-dismiss="modal" aria-label="Close">
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 11L11 1M1 1L11 11" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </button>
                </div>
            </div>
            <div class="modal-body d-flex flex-column gap-3">
                <div>{{ 'Standard.Partner' | translate }}</div>
                <div class="form-control form-control-disabled d-flex align-items-center gap-3" disabled>
                    <div class="btn btn-square btn-{{transferPartner.partner.name[0] | uppercase}}">{{transferPartner.partner.name[0] | uppercase}}</div>
                    {{ transferPartner.partner.name }}
                </div>
                <div>
                    {{ 'Standard.Title' | translate}}
                    <input type="text" class="form-control" [(ngModel)]="transferPartner.caseTransfer.title">
                </div>
                <div>
                    {{ 'Standard.Description' | translate }}
                    <textarea class="form-control form-control-textArea" cols="30" rows="10" [(ngModel)]="transferPartner.caseTransfer.description"></textarea>
                </div>
                <div class="form-group row" *ngIf="!!invoiceTypes && invoiceTypes.length > 0">
                    <label for="invoiceType" class="col-12 col-md-3 col-form-label">{{ 'Standard.InvoiceType' | translate }}</label>
                    <div class="col-12 col-md-9">
                        <select class="form-control borderless form-control form-control-dropdown" id="invoiceType" [(ngModel)]="case.invoiceTypeId" (change)="updateInvoiceType(case.invoiceTypeId)">
                            <option *ngFor="let x of invoiceTypes" [value]="x.id">{{ x.value | translate }} {{ x.name | translate }}</option>
                        </select>
                    </div>
                </div>
                <div>
                    {{ 'Standard.RequisitionNumber' | translate}}
                    <input type="text" class="form-control" [(ngModel)]="transferPartner.caseTransfer.requisitionNumber" [disabled]="!!invoiceTypes && invoiceTypes.length > 0">
                </div>
                <div>
                    {{ 'Standard.Reference' | translate}}
                    <input type="text" class="form-control" [(ngModel)]="transferPartner.caseTransfer.reference">
                </div>
                <div>
                    {{ 'Standard.ContactPerson' | translate }}
                    <select class="form-control" [(ngModel)]="transferPartner.caseTransfer.responsibleId">
                        <option [ngValue]="null" disabled>{{ 'Standard.NoneChosen' | translate }}</option>
                        <option value="{{contact.id}}" *ngFor="let contact of transferPartner.responsibles">{{contact.name}}</option>
                    </select>
                </div>
                <div class="mt-3 flex-between text-bold" *ngIf="!isTaurus">
                    {{'Word.Invoicing' | translate }}
                    <div class="position-relative">
                        <div (click)="showPartnerOptions = !showPartnerOptions">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="hero-icon cursor-pointer" [ngClass]="{'text-primary': !!showPartnerOptions}">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M10.343 3.94c.09-.542.56-.94 1.11-.94h1.093c.55 0 1.02.398 1.11.94l.149.894c.07.424.384.764.78.93.398.164.855.142 1.205-.108l.737-.527a1.125 1.125 0 011.45.12l.773.774c.39.389.44 1.002.12 1.45l-.527.737c-.25.35-.272.806-.107 1.204.165.397.505.71.93.78l.893.15c.543.09.94.56.94 1.109v1.094c0 .55-.397 1.02-.94 1.11l-.893.149c-.425.07-.765.383-.93.78-.165.398-.143.854.107 1.204l.527.738c.32.447.269 1.06-.12 1.45l-.774.773a1.125 1.125 0 01-1.449.12l-.738-.527c-.35-.25-.806-.272-1.203-.107-.397.165-.71.505-.781.929l-.149.894c-.09.542-.56.94-1.11.94h-1.094c-.55 0-1.019-.398-1.11-.94l-.148-.894c-.071-.424-.384-.764-.781-.93-.398-.164-.854-.142-1.204.108l-.738.527c-.447.32-1.06.269-1.45-.12l-.773-.774a1.125 1.125 0 01-.12-1.45l.527-.737c.25-.35.273-.806.108-1.204-.165-.397-.505-.71-.93-.78l-.894-.15c-.542-.09-.94-.56-.94-1.109v-1.094c0-.55.398-1.02.94-1.11l.894-.149c.424-.07.765-.383.93-.78.165-.398.143-.854-.107-1.204l-.527-.738a1.125 1.125 0 01.12-1.45l.773-.773a1.125 1.125 0 011.45-.12l.737.527c.35.25.807.272 1.204.107.397-.165.71-.505.78-.929l.15-.894z" />
                                <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                            </svg>
                        </div>
                        <div class="position-absolute bg-white font-weight-normal" style="top:100%;right:0;width:15rem;padding:1rem;border:1px solid #777777;z-index:10;" [ngStyle]="{ 'display': (!!showPartnerOptions ? 'block' : 'none') }">
                            <div class="mt-3">{{ 'Word.Standard' | translate }}</div>
                            <select id="partnerInvoiceStandard" class="form-control" [(ngModel)]="partnerInvoiceOptions.standard" (change)="savePartnerInputOptions()">
                                <option value="case">{{ 'Word.Case' | translate }}</option>
                                <option value="company">{{ 'Header.Company' | translate }}</option>
                                <option value="property">{{ 'Standard.PropertyOwner' | translate }}</option>
                                <option value="auto">Auto</option>
                            </select>
                            <div class="mt-3">{{ 'Forms.Options' | translate }}</div>
                            <div class="flex-between w-100">
                                <div style="flex:6;">{{ 'Word.Case' | translate }}</div>
                                <div style="flex:1;"><input type="checkbox" [(ngModel)]="partnerInvoiceOptions.visible.case" (change)="savePartnerInputOptions()"></div>
                            </div>
                            <div class="flex-between w-100">
                                <div style="flex:6;">{{ 'Header.Company' | translate }}</div>
                                <div style="flex:1;"><input type="checkbox" [(ngModel)]="partnerInvoiceOptions.visible.company" (change)="savePartnerInputOptions()"></div>
                            </div>
                            <div class="flex-between w-100">
                                <div style="flex:6;">{{ 'Standard.PropertyOwner' | translate }}</div>
                                <div style="flex:1;"><input type="checkbox" [(ngModel)]="partnerInvoiceOptions.visible.property" (change)="savePartnerInputOptions()"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-column gap-3" *ngIf="!isTaurus && !!partnerInvoiceOptions && partnerInvoiceOptions.numVisible > 1 && !!transferPartner">
                    {{'Standard.Recipient' | translate}}
                    <select class="form-control" [(ngModel)]="transferPartner.invoice" (change)="transferPartner.setAddresses()">
                        <option value="case" *ngIf="!!partnerInvoiceOptions.visible.case">{{ 'Standard.Case' | translate }}</option>
                        <option value="company" *ngIf="!!partnerInvoiceOptions.visible.company">{{ 'Settings.Company' | translate }}</option>
                        <option value="property" *ngIf="!!transferPartner.propertyOwner && !!partnerInvoiceOptions.visible.property">{{ 'Standard.PropertyOwner' | translate }}</option>
                    </select>
                </div>
                <div class="card borderless text-black">
                    <div class="card-body bg-grey text-black d-flex flex-column" *ngIf="transferPartner.invoice == 'case'">
                        <div class="mb-3 text-bold">{{ 'Partners.InformationPassedOnToPartner' | translate }}</div>
                        <div class="d-flex dataRow">
                            <div class="text-muted dataKey">{{ 'Standard.Name' | translate }}</div>
                            <div class="dataValue">{{ transferPartner.caseTransfer.invoice.name }}</div>
                        </div>
                        <div class="d-flex dataRow">
                            <div class="text-muted dataKey">{{ 'Standard.Address' | translate }}</div>
                            <div class="dataValue">{{ transferPartner.caseTransfer.invoice.address }}</div>
                        </div>
                        <div class="d-flex dataRow">
                            <div class="text-muted dataKey">{{ 'Standard.ZipAndCity' | translate }}</div>
                            <div class="dataValue">{{ transferPartner.caseTransfer.invoice.zipCode }} {{ transferPartner.caseTransfer.invoice.city }}</div>
                        </div>
                        <div class="d-flex dataRow">
                            <div class="text-muted dataKey">{{ 'Standard.Email' | translate }}</div>
                            <div class="dataValue">{{ transferPartner.caseTransfer.invoice.email }}</div>
                        </div>
                        <div class="d-flex dataRow">
                            <div class="text-muted dataKey">{{ 'Standard.Phone' | translate }}</div>
                            <div class="dataValue">{{ transferPartner.caseTransfer.invoice.phone }}</div>
                        </div>
                        <div class="d-flex dataRow">
                            <div class="text-muted dataKey">{{ 'Company.VatNumber' | translate }}</div>
                            <div class="dataValue">{{ transferPartner.caseTransfer?.cvr }}</div>
                        </div>
                        <div class="d-flex dataRow">
                            <div class="text-muted dataKey">{{ 'Standard.EAN' | translate }}</div>
                            <div class="dataValue">{{ transferPartner.caseTransfer?.ean }}</div>
                        </div>
                    </div>
                    <div class="card-body bg-grey text-black d-flex flex-column" *ngIf="transferPartner.invoice == 'company'">
                        <div class="mb-3 text-bold">{{ 'Partners.InformationPassedOnToPartner' | translate }}</div>
                        <div class="d-flex dataRow">
                            <div class="text-muted dataKey">{{ 'Standard.Name' | translate }}</div>
                            <div class="dataValue">{{ transferPartner.caseTransfer?.invoice?.name }}</div>
                        </div>
                        <div class="d-flex dataRow">
                            <div class="text-muted dataKey">{{ 'Properties.Property' | translate }}</div>
                            <div class="dataValue">{{ transferPartner.caseTransfer.propertyName }}</div>
                        </div>
                        <div class="d-flex dataRow">
                            <div class="text-muted dataKey">{{ 'Standard.Address' | translate }}</div>
                            <div class="dataValue">{{ transferPartner.caseTransfer?.invoice?.address }}</div>
                        </div>
                        <div class="d-flex dataRow">
                            <div class="text-muted dataKey">{{ 'Standard.ZipAndCity' | translate }}</div>
                            <div class="dataValue">{{ transferPartner.caseTransfer?.invoice?.zipCode }} {{ transferPartner.caseTransfer?.invoice?.city }}</div>
                        </div>
                        <div class="d-flex dataRow">
                            <div class="text-muted dataKey">{{ 'Standard.Email' | translate }}</div>
                            <div class="dataValue">{{ transferPartner.caseTransfer?.invoice?.email }}</div>
                        </div>
                        <div class="d-flex dataRow">
                            <div class="text-muted dataKey">{{ 'Standard.Phone' | translate }}</div>
                            <div class="dataValue">{{ transferPartner.caseTransfer?.invoice?.phone }}</div>
                        </div>
                        <div class="d-flex dataRow">
                            <div class="text-muted dataKey">{{ 'Company.VatNumber' | translate }}</div>
                            <div class="dataValue">{{ transferPartner.caseTransfer.cvr }}</div>
                        </div>
                        <div class="d-flex dataRow">
                            <div class="text-muted dataKey">{{ 'Standard.EAN' | translate }}</div>
                            <div class="dataValue">{{ transferPartner.caseTransfer.ean }}</div>
                        </div>
                    </div>
                    <div class="card-body bg-grey text-black d-flex flex-column" *ngIf="transferPartner.invoice == 'property'">
                        <div class="mb-3 text-bold">{{ 'Partners.InformationPassedOnToPartner' | translate }}</div>
                        <div class="d-flex dataRow">
                            <div class="text-muted dataKey">{{ 'Standard.Name' | translate }}</div>
                            <div class="dataValue">{{ transferPartner.caseTransfer?.invoice?.name }}</div>
                        </div>
                        <div class="d-flex dataRow">
                            <div class="text-muted dataKey">{{ 'Standard.Address' | translate }}</div>
                            <div class="dataValue">{{ transferPartner.caseTransfer?.invoice?.address }}</div>
                        </div>
                        <div class="d-flex dataRow">
                            <div class="text-muted dataKey">{{ 'Standard.ZipAndCity' | translate }}</div>
                            <div class="dataValue">{{ transferPartner.caseTransfer?.invoice?.zipCode }} {{ transferPartner.caseTransfer?.invoice?.city }}</div>
                        </div>
                        <div class="d-flex dataRow">
                            <div class="text-muted dataKey">{{ 'Standard.Phone' | translate }}</div>
                            <div class="dataValue">{{ transferPartner.caseTransfer?.invoice?.phone }}</div>
                        </div>
                        <div class="d-flex dataRow">
                            <div class="text-muted dataKey">{{ 'Company.VatNumber' | translate }}</div>
                            <div class="dataValue">{{ transferPartner.caseTransfer?.cvr }}</div>
                        </div>
                        <div class="d-flex dataRow">
                            <div class="text-muted dataKey">{{ 'Standard.EAN' | translate }}</div>
                            <div class="dataValue">{{ transferPartner.caseTransfer?.ean }}</div>
                        </div>
                    </div>
                    <div class="card-body bg-grey text-black d-flex flex-column" *ngIf="transferPartner.invoice == 'propertyOwner'">
                        <div class="mb-3 text-bold" *ngIf="transferPartner.caseTransfer.requisitionNumber != 'REKLAMATION'">{{ 'Partners.InformationPassedOnToPartner' | translate }}</div>
                        <div class="mb-3 text-bold" *ngIf="transferPartner.caseTransfer.requisitionNumber == 'REKLAMATION'">{{ 'Partners.InformationPassedOnToPartnerReclamation' | translate }}</div>
                        <div class="d-flex dataRow">
                            <div class="text-muted dataKey">{{ 'Standard.Name' | translate }}</div>
                            <div class="dataValue">{{ transferPartner.caseTransfer?.invoice?.name }}</div>
                        </div>
                        <div class="d-flex dataRow">
                            <div class="text-muted dataKey">{{ 'Standard.Address' | translate }}</div>
                            <div class="dataValue">{{ transferPartner.caseTransfer?.invoice?.address }}</div>
                        </div>
                        <div class="d-flex dataRow">
                            <div class="text-muted dataKey">{{ 'Standard.ZipAndCity' | translate }}</div>
                            <div class="dataValue">{{ transferPartner.caseTransfer?.invoice?.zipCode }} {{ transferPartner.caseTransfer?.invoice?.city }}</div>
                        </div>
                        <div class="d-flex dataRow">
                            <div class="text-muted dataKey">{{ 'Standard.Phone' | translate }}</div>
                            <div class="dataValue">{{ transferPartner.caseTransfer?.invoice?.phone }}</div>
                        </div>
                        <div class="d-flex dataRow">
                            <div class="text-muted dataKey">{{ 'Company.VatNumber' | translate }}</div>
                            <div class="dataValue">{{ transferPartner.caseTransfer?.cvr }}</div>
                        </div>
                        <div class="d-flex dataRow" *ngIf="transferPartner.caseTransfer.requisitionNumber != 'REKLAMATION'">
                            <div class="text-muted dataKey">{{ 'Standard.EAN' | translate }}</div>
                            <div class="dataValue">{{ transferPartner.caseTransfer?.ean }}</div>
                        </div>
                    </div>
                </div>
                <div class="card" *ngIf="transferPartner.invoice == 'propertyOwner' && transferPartner.caseTransfer.requisitionNumber != 'REKLAMATION'">
                    <div class="card-body badge-primary">
                        <div class="d-flex align-items-start gap-3">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="hero-icon text-primary">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                            </svg>
                            <div>
                                <div class="text-primary">{{ 'Invoicing.HowInvoiceIsSent' | translate }}</div>
                                <div>{{ 'Taurus.TaurusReceivesInvoiceWhenCaseIsClosed' | translate }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="text-bold cursor-pointer" (click)="transferPartner.caseTransfer.companyMessage = ''" *ngIf="transferPartner.caseTransfer.companyMessage == null">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="hero-icon">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m6-6H6" />
                    </svg>
                    <span>{{'Partners.AddMessageToPartner' | translate }}</span>
                </div>
                <div *ngIf="transferPartner.caseTransfer.companyMessage != null">
                    {{ 'Standard.Message' | translate }}
                    <textarea class="form-control form-control-textArea" cols="30" rows="10" [(ngModel)]="transferPartner.caseTransfer.companyMessage"></textarea>
                </div>
                <button class="btn btn-primary mt-3 d-flex gap-3 w-fit" (click)="openFileSelector()">
                    <div class="text-black cursor-pointer">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="black" class="hero-icon">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M18.375 12.739l-7.693 7.693a4.5 4.5 0 01-6.364-6.364l10.94-10.94A3 3 0 1119.5 7.372L8.552 18.32m.009-.01l-.01.01m5.699-9.941l-7.81 7.81a1.5 1.5 0 002.112 2.13" />
                        </svg>
                    </div>
                    {{ 'Buttons.ChooseImage' | translate }}
                </button>
                <div class="mt-3" *ngIf="!!transferPartner && !!transferPartner.caseTransfer && !!transferPartner.caseTransfer.files.length">
                    <div class="d-flex flex-between">
                        <div class="text-bold">{{ 'Standard.AttachedFiles' | translate }}</div>
                        <div>{{ transferPartner.caseTransfer.files.length }} {{ (transferPartner.caseTransfer.files.length == 1 ? ('Standard.File' | translate) : ('Standard.Files' | translate)) | lowercase }}</div>
                    </div>
                    <div (click)="openFileSelector()">
                        <file-thumbs [files]="selectedFiles"></file-thumbs>
                    </div>
                </div>
            </div>
            <div class="modal-footer justify-content-end">
                <button class="btn btn-secondary" data-dismiss="modal" (click)="reset()">{{'Buttons.Cancel' | translate}}</button>
                <button class="btn btn-primary" data-dismiss="modal" (click)="sendCase()">{{ 'Buttons.SendToPartner' | translate }}</button>
            </div>
        </div>
    </div>
</div>

<!-- Partner details -->
<div id="subcontractorCaseDetailsModal" class="modal">
    <div class="modal-dialog">
        <div class="modal-content" *ngIf="!!partnerCase">
            <div class="modal-header">
                <h5 class="modal-title d-flex align-items-center gap-3">
                    <div class="btn btn-square btn-{{partnerCase.partner.companyName[0] | uppercase}}">{{partnerCase.partner.companyName[0] | uppercase}}</div>
                    {{partnerCase.partner.companyName}}
                </h5>
                <button type="button" class="close cursor-pointer" data-dismiss="modal" aria-label="Close">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 11L11 1M1 1L11 11" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </button>
            </div>
            <div class="modal-body">
                <!-- Case Info -->
                <div class="card">
                    <div class="card-header">
                        <h4>{{ 'Standard.CaseDetails' | translate }}</h4>
                    </div>
                    <div class="card-body">
                        <!-- Case Number -->
                        <div class="form-group flex-between gap-3">
                            <label>{{ 'Standard.CaseNumber' | translate }}</label>
                            {{ !!partnerCase.case.caseNumber ? partnerCase.case.caseNumber : ('Standard.NoOrderNo' | translate) }}
                        </div>
                        <!-- Case Status -->
                        <div class="form-group flex-between gap-3">
                            <label>{{ 'Standard.Status' | translate }}</label>
                            <span class="badge {{ subcontractors.getBadgeColor(partnerCase.case.status.id) }}">{{ partnerCase.case.status.name | translate }}</span>
                        </div>
                        <!-- OS Status -->
                        <div class="form-group flex-between gap-3" *ngIf="!!partnerCase.case.osStatus">
                            <label>{{ 'Partner.ActualStatus' | translate }}</label>
                            <span class="badge" [ngStyle]="{'background-color': partnerCase.case.osStatus.color, 'color':getOsTextColor(partnerCase.case.osStatus.color)}">{{ partnerCase.case.osStatus.text }}</span>
                        </div>
                        <!-- RequisitionNumber -->
                        <div class="form-group flex-between gap-3">
                            <label class="mr-3">{{ 'Standard.RequisitionNumber' | translate }}</label>
                            {{ partnerCase.case.rekvisition }}
                        </div>
                        <!-- Reference -->
                        <div class="form-group flex-between gap-3">
                            <label>{{ 'Standard.Reference' | translate }}</label>
                            {{ partnerCase.case.reference }}
                        </div>
                    </div>
                    <!-- Description -->
                    <div class="card-footer">
                        <div class="form-group">
                            <label>{{ 'Standard.Description' | translate }}</label>
                            {{ partnerCase.case.description }}
                        </div>
                    </div>
                </div>
                <!-- Partner Offers -->
                <div *ngIf="!!partnerCase && !!partnerCase.offer && !!partnerCase.offer.offers.length">
                    <div class="card" *ngFor="let offer of partnerCase.offer.offers">
                        <div class="card-header">{{ ('Standard.OfferFromPartner' | translate) | uppercase }}</div>
                        <div class="card-body">
                            <div class="d-flex justify-content-between">
                                <div>{{ 'Offers.OfferNumber' | translate }}</div>
                                <div>{{ offer.offerNumber }}</div>
                            </div>
                            <div class="d-flex justify-content-between">
                                <div>{{ 'Standard.Regarding' | translate }}</div>
                                <div>{{ offer.title }}</div>
                            </div>
                            <div class="d-flex justify-content-end" *ngIf="offer.status == 'Offers.AwaitingAccept' || offer.status == 'Offers.Accepted' || offer.status == 'Offers.Rejected'">
                                <span>{{ offer.price | number: '1.2-2':'da' }},-{{ 'Standard.Subtexts.ExcludingVAT' | translate }}</span>
                                <span>{{ (offer.price * 1.25) | number: '1.2-2':'da' }},- {{ 'Standard.Subtexts.IncludingVAT' | translate }}</span>
                            </div>
                            <div class="d-flex justify-content-between">
                                {{ 'Offer.OfferStatus' | translate }}:
                                <span class="badge badge-sm" [ngClass]="{
                                    'badge-success': offer.status == 'Offers.Accepted',
                                    'badge-light': offer.status == 'Offers.AwaitingAccept',
                                    'badge-warning': offer.status == 'Offers.New',
                                    'badge-danger': offer.status == 'Offer.Canceled'}">
                                    <span *ngIf="offer.status == 'Offers.AwaitingAccept'">
                                        {{ 'Offer.NewOfferReceived' | translate }}
                                    </span>
                                    <span *ngIf="offer.status != 'Offers.AwaitingAccept'">
                                        {{ offer.status | translate }}
                                    </span>
                                </span>
                            </div>
                        </div>
                        <div class="card-footer" *ngIf="offer.status == 'Offers.AwaitingAccept'">
                            <div class="d-flex justify-content-between">
                                <button class="btn btn-sm btn-success" (click)="acceptOffer(offer)" data-dismiss="modal">
                                    {{ 'Buttons.Accept' | translate }}
                                </button>
                                <div class="m-auto">
                                    <a href="https://jubloapi.azure-api.net/api/shared/attachments/{{offer.fileId}}" class="text-decoration-none" *ngIf="offer.fileId != null">
                                        <i class="fas fa-file-pdf align-text-top"></i> {{ 'Buttons.ShowOffer' | translate }}
                                    </a>
                                </div>
                                <button class="btn btn-sm btn-danger" (click)="rejectOffer(offer)" data-dismiss="modal">
                                    {{ 'Buttons.Reject' | translate }}
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
                <!-- Company Info -->
                <div class="card">
                    <div class="card-header bg-white borderless">
                        <h4 class="d-flex align-items-center gap-3">
                            {{ 'Company.CompanyDetails' | translate}}
                        </h4>
                    </div>
                    <div class="card-body">
                        <!-- Address -->
                        <div class="form-group flex-between gap-3">
                            <label class="mr-3">{{ 'Standard.Address' | translate }}</label>
                            {{ partnerCase.partner.address }}
                        </div>
                        <!-- E-mail -->
                        <div class="form-group flex-between gap-3">
                            <label class="mr-3">{{ 'Standard.Email' | translate }}</label>
                            {{ partnerCase.partner.email }}
                        </div>
                        <!-- Phone -->
                        <div class="form-group flex-between gap-3">
                            <label class="mr-3">{{ 'Standard.Phone' | translate }}</label>
                            {{ partnerCase.partner.phone }}
                        </div>
                    </div>
                    <div class="card-footer bg-white">
                        <!-- Responsible -->
                        <div class="form-group flex-between gap-3">
                            <label class="mr-3">{{ 'Standard.Responsible' | translate }}</label>
                            {{ partnerCase.partner.responsible?.name }}
                        </div>
                        <div class="form-group flex-between gap-3">
                            <label class="mr-3">{{ 'Standard.Email' | translate }}</label>
                            {{ partnerCase.partner.responsible?.email }}
                        </div>
                        <!-- Responsible Phone -->
                        <div class="form-group flex-between gap-3">
                            <label class="mr-3">{{ 'Standard.Phone' | translate }}</label>
                            {{ partnerCase.partner.responsible?.phone }}
                        </div>

                    </div>
                </div>
                <!-- Case Addresses -->
                <div class="card">
                    <div class="card-header d-flex">
                        <button class="btn mr-1" [ngClass]="partnerCaseAddress == 'customer' ? 'btn-secondary' : 'btn-light'" (click)="partnerCaseAddress = 'customer'">{{ 'Standard.Customer' | translate }}</button>
                        <button class="btn mr-1" [ngClass]="partnerCaseAddress == 'delivery' ? 'btn-secondary' : 'btn-light'" (click)="partnerCaseAddress = 'delivery'">{{ 'Standard.Delivery' | translate }}</button>
                    </div>
                    <div class="card-body" *ngIf="partnerCaseAddress == 'customer'">
                        <div class="text-bold">{{ partnerCase.case.customer.name }}</div>
                        <div>{{ partnerCase.case.customer.address }}</div>
                        <div>{{ partnerCase.case.customer.zipCode }} {{ partnerCase.case.customer.city }}</div>
                    </div>
                    <div class="card-body" *ngIf="partnerCaseAddress == 'delivery'">
                        <div class="text-bold">{{ partnerCase.case.delivery.name }}</div>
                        <div>{{ partnerCase.case.delivery.address }}</div>
                        <div>{{ partnerCase.case.delivery.zipCode }} {{ partnerCase.case.delivery.city }}</div>
                    </div>
                    <div class="card-footer" *ngIf="partnerCaseAddress == 'customer' && (!!partnerCase.case.customer.mobile || !!partnerCase.case.customer.phone )">
                        <div>{{ partnerCase.case.customer.mobile }}</div>
                        <div>{{ partnerCase.case.customer.phone }}</div>
                    </div>
                    <div class="card-footer" *ngIf="partnerCaseAddress == 'delivery' && (!!partnerCase.case.delivery.mobile || !!partnerCase.case.delivery.phone )">
                        <div>{{ partnerCase.case.delivery.mobile }}</div>
                        <div>{{ partnerCase.case.delivery.phone }}</div>
                    </div>
                </div>
            </div>
            <div class="modal-footer flex-row-reverse">
                <button class="btn btn-success" data-dismiss="modal">{{ 'Buttons.Close' | translate }}</button>
            </div>
        </div>
    </div>
</div>

<div id="filterTradeGroups" class="modal fade">
    <div class="modal-dialog modalSlider">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{ 'Buttons.Filter' | translate }} {{ ('Standard.TradeGroup' | translate ) | lowercase }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 11L11 1M1 1L11 11" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </button>
            </div>
            <div class="modal-body">
                <table class="table table-striped" aria-label="Trade groups">
                    <thead>
                        <th>{{ 'Standard.TradeGroup' | translate }}</th>
                    </thead>
                    <tbody>
                        <tr class="font-weight-bold cursor-pointer" (click)="subcontractors.filterTradeGroup(null)" [ngClass]="{ 'text-normal text-muted text-strike': subcontractors.filteredTradeGroups.includes(null) }">
                            <td class="p-3">{{ 'Standard.NoType' | translate }}</td>
                            <td class="p-3"></td>
                        </tr>
                        <tr class="font-weight-bold cursor-pointer" *ngFor="let tradeGroup of subcontractors.tradeGroups" (click)="subcontractors.filterTradeGroup(tradeGroup.id)"
                            [ngClass]="{ 'text-normal text-muted text-strike': subcontractors.filteredTradeGroups.includes(tradeGroup.id) }">
                            <td class="p-3">{{ tradeGroup.name }}</td>
                            <td class="p-3"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="modal-footer d-flex justify-content-end">
                <button class="btn btn-secondary" data-dismiss="modal">{{ 'Buttons.Close' | translate }}</button>
            </div>
        </div>
    </div>
</div>

<file-list [files]="files" (modalId)="fileModalId = $event" (selected)="selectFiles($event);">
</file-list>
